import React, { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';
import { Store } from '../../store/Store';
import { checkSession } from './userManagementUtils';
import { useLocation, useNavigate } from 'react-router-dom';
import Login from './login/Login';
import SignUp from './signup/SignUp';
import ResetPassword from './resetPassword/ResetPassword';
import VerificationCode from './verificationCode/VerificationCode';
import { Spin } from 'antd';

const UserManager = () => {
    const snapShot = useSnapshot(Store);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        checkSession().then(() => {
            Store.isLoggedIn = true;
        }).catch(() => {
            Store.isLoggedIn = false;
            Store.isInitialized = true;
        });
    }, []);

    // Redirect if logged in
    useEffect(() => {
        if (snapShot.isLoggedIn && location.pathname !== '/') {
            navigate('/');
        }
        if ((!snapShot.isLoggedIn && location.pathname === '/') || (!snapShot.isLoggedIn && location.pathname !== '/')) {
            navigate('/login');
        }
    }, [snapShot.isLoggedIn, location.pathname, navigate]);

    useEffect(() => {
        switch (location.pathname) {
            case '/login':
                break;
            case '/signup':
                if (!snapShot.isLoggedIn) {
                    navigate('/signup');
                } else {
                    navigate('/login');
                }
                break;
            case '/reset-password':
                if (!snapShot.isLoggedIn) {
                    navigate('/reset-password');
                } else {
                    navigate('/login');
                }
                break;
            case '/verify':
                if (!snapShot.isLoggedIn) {
                    navigate('/verify');
                } else {
                    navigate('/login');
                }
                break;
            default:
        }
    }, [location.pathname, snapShot.isLoggedIn, navigate]);

    return (
        <>
            {!snapShot.isInitialized ? (
                <div className="loader__block">
                    <Spin className="spin__loader" tip="Loading" size="large"></Spin>
                </div>
            ) : <div className="cont">
                {location.pathname === '/login' && <Login />}
                {location.pathname === '/signup' && <SignUp />}
                {location.pathname === '/reset-password' && <ResetPassword />}
                {location.pathname === '/verify' && <VerificationCode />}
            </div>}
        </>
    );
};

export default UserManager;
